<template>
  <div class="map-locations__container">
    <h2 class="map-locations__title map-locations__title--mobile">
      {{ title }}
    </h2>
    <div class="map">
      <GmapMap
        class="map__map map__map--locations"
        map-type-id="roadmap"
        :center="userLocation.lng ? userLocation : defaultLocation"
        :zoom="14"
        :options="{
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          disableDefaultUi: true,
          styles: styles.map
        }"
      >
        <gmap-cluster :options="{styles:styles.cluster[0]}">
          <gmap-marker
            v-for="(m, index) in allLocations"
            :position="m.location"
            :key="index"
            :icon="styles.marker"
          />
        </gmap-cluster>
      </GmapMap>
    </div>
    <div class="map-locations__location-block">
      <h2 class="map-locations__title">
        {{ title }}
      </h2>
      <div class="map-locations__top-container">
        <div class="map-locations__input-container">
          <input
            type="text"
            placeholder="Enter location or postcode"
            class="map-locations__input"
            v-model="query"
            @keyup.enter="searchUserLocation"
          >
          <p class="map-locations__input-subtitle">
            {{ subtitle }}
          </p>
        </div>
        <button class="map-locations__button" @click="searchUserLocation">
          {{ buttonText }}
        </button>
      </div>
      <locations :locations="theLocations" :user-location="userLocation" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import locations from './locations.vue';
import styles from '../map-styles';

export default {
  name: 'MapLocations',
  components: { locations },
  data: () => ({
    query: '',
    userLocation: {
      lng: 0,
      lat: 0
    },
    defaultLocation: {
      lat: 51.4590811,
      lng: -2.5904453
    },
    styles: {
      map: styles,
      cluster: {
        width: 30,
        height: 30,
        className: 'custom-clustericon-1'
      },
      marker: {
        url: '/app/themes/knotistry/images/icons/pin.png',
        size: { width: 20, height: 20, f: 'px', b: 'px' },
        origin: { x: 0, y: 0, f: 'px', b: 'px' },
        scaledSize: { width: 20, height: 20, f: 'px', b: 'px' }
      }
    },
    allLocations: []
  }),
  props: {
    title: {
      type: String,
      default: () => ''
    },
    subtitle: {
      type: String,
      default: () => ''
    },
    buttonText: {
      type: String,
      default: () => ''
    },
    locations: {
      type: Array,
      default: () => []
    }
  },
  mounted () {
    this.allLocations = this.locations;
    this.getFitters();
  },
  methods: {
    async getFitters () {
      const { data } = await axios.get('/wp-json/naked/v1/fitting_locations');
      if (data.length) return (this.allLocations = data);
    },
    async searchUserLocation () {
      if (this.query) {
        const { data } = await axios.get('/wp-json/naked/v1/google/places', {
          params: {
            query: this.query.replace(' ', '+')
          }
        });

        if (data.geometry.location) {
          return (this.userLocation = data.geometry.location);
        }
      }
      return (this.userLocation = { lng: 0, lat: 0 });
    },
    getDistance (location) {
      return this.userLocation.lat !== 0 && this.userLocation.lng !== 0
        ? this.locationDistanceCalculation(this.userLocation, location)
        : null;
    },
    locationDistanceCalculation (
      location1,
      location2,
      isMiles = true,
      decimalPlaces = 1
    ) {
      const { lng: lng1, lat: lat1 } = location1;
      const { lng: lng2, lat: lat2 } = location2;
      const R = 6371e3; // metres
      const miles = 0.000621371;
      const km = 1.60934;
      const φ1 = (lat1 * Math.PI) / 180;
      const φ2 = (lat2 * Math.PI) / 180;
      const Δφ = ((lat2 - lat1) * Math.PI) / 180;
      const Δλ = ((lng2 - lng1) * Math.PI) / 180;
      const a =
        Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
        Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      let output = R * c * miles;
      if (!isMiles) output = output * km;
      return parseFloat(output.toFixed(decimalPlaces));
    }
  },
  computed: {
    theLocations () {
      return this.locations.map(loc => ({
        ...loc,
        distance: this.getDistance(loc.location)
      }));
    }
  }
};
</script>
